import { IconArrowRightRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { PDPCustomAttributeKeys } from '@common/test-automation';

export interface ShopLinkProps {
  shop_name: string;
  onClick: () => void;
}

export const ShopLink: React.FC<React.PropsWithChildren<ShopLinkProps>> = ({ shop_name, onClick }) => {
  return (
    <Wrapper
      type='button'
      onClick={onClick}
      className={Typography.BODY_14_MEDIUM}
      data-custom-ta-key={PDPCustomAttributeKeys.PDP_SHOP_NAME_1}
    >
      <ShopName>{shop_name}</ShopName>
      {shop_name && <IconArrowRightRegular width={18} height={18} color='textTertiary' />}
    </Wrapper>
  );
};

const Wrapper = styled.button`
  padding-left: 16px;
  height: 42px;
  display: flex;
  align-items: center;
  color: ${vars.color.textTertiary};
`;

const ShopName = styled.span`
  position: relative;
  top: 0.5px;
  margin: 0 1px 0 0;
`;
